import { AppSettingsConfig } from './interfaces/app-settings.interface';

export const AppSettings: AppSettingsConfig = {
  env: {
    name: 'SHIPA',
  },
  settings: {
    default: {
      isoCode: 'ae',
      countryPlaceId: 'ChIJvRKrsd9IXj4RpwoIwFYv0zM',
      latlng: { lat: 25.0692834, lng: 55.1417222 },
      tel: {
        text: '600 574472',
        number: '600 574472',
      },
      email: 'customer@shipadelivery.com',
      labels: {
        address: 'Location (city, area, neighborhood, Makani)',
        addressDetails: 'Address details (street name, building name, apt.#)',
      },
      errors: {
        geolocation: {
          '0': "Couldn't access your location. Please try again.",
          '1': 'Permission to access your location was denied.\nPlease enable from your browser settings.',
          '2': "Couldn't access your location. Please try again.",
          '3': 'Session timed out. Please try again.',
        },
        geocoding: {
          '0': 'Country not supported',
          '1': 'No results for this position',
        },
      },
    },
    KWT: {
      isoCode: 'kw',
      countryPlaceId: 'ChIJoVHqvj82xT8R0u3Yks1rcnQ',
      latlng: { lat: 29.2703218, lng: 47.7745176 },
      tel: {
        text: '+965 222 75460',
        number: '+96522275460',
      },
      email: 'customer@shipadelivery.com',
      errors: {
        geolocation: {
          '0': "Couldn't access your location. Please try again.",
          '1': 'Permission to access your location was denied.\nPlease enable from your browser settings.',
          '2': "Couldn't access your location. Please try again.",
          '3': 'Session timed out. Please try again.',
        },
        geocoding: {
          '0': 'Country not supported',
          '1': 'No results for this position',
        },
      },
    },
    SAU: {
      isoCode: 'sa',
      countryPlaceId: 'ChIJQSqV5z-z5xURm7YawktQYFk',
      latlng: { lat: 24.731818, lng: 46.728451 },
      tel: {
        text: '800 5000502',
        number: '8005000502',
      },
      email: 'customer@shipadelivery.com',
      errors: {
        geolocation: {
          '0': "Couldn't access your location. Please try again.",
          '1': 'Permission to access your location was denied.\nPlease enable from your browser settings.',
          '2': "Couldn't access your location. Please try again.",
          '3': 'Session timed out. Please try again.',
        },
        geocoding: {
          '0': 'Country not supported',
          '1': 'No results for this position',
        },
      },
    },
  },
};
